import { CommunityInterface } from '../types/community-interface'

type CommunityUrlFields = Pick<CommunityInterface, 'path' | 'domainName'>

export const getCommunityUrl = (community: CommunityUrlFields) =>
  `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${community.domainName}/community/${community.path}`

export const getLoginCommunityUrl = (community: CommunityUrlFields) =>
  `${window.location.origin}/dashboard/user-domain/login-link?domainName=${
    community.domainName
  }&redirectUrl=${getCommunityUrl(community)}`
